export default "__VITE_ASSET__C5icy7dL__"